export const PROFILE_PERSONAL_INFO_INHABITANT_DATA = {
  full_name: 'Ayden Dominic Alejandro Carrillo',
  gdpr_info:
    'The individual has explicitly requested that all personal communication be conducted in compliance with GDPR regulations and stored only for the legally required retention period.',
  middle_name: 'Dominic Alejandro',
  name_info: 'Ayden Carrillo, PhD, MSc, BSc (Hons)',
  notes:
    'Customer prefers detailed written communication and usually responds within one business day. Has previously requested that appointments be scheduled at least 48 hours in advance.',
  preferred_communication: { id: 1, value: 'Email' },
  salutation: { id: 179, salutation: 'Sehr geehrter Herr' },
  status: { id: 367, value: 'With child' },
  title:
    'Doctor of Philosophy (PhD) in Computer Science, Master of Science (MSc) in Artificial Intelligence and Distributed Systems',
}
